/**
 * Development-only logging utilities
 * These functions only output to console in development builds
 */

// Show logs only if:
// 1. Running dev server with development env (npm start)
// 2. Running dev server with production env should NOT show logs (npm run start:production)
// 3. Built production should NOT show logs (npm run build:production)
const isDevelopment = process.env.NODE_ENV === 'development' && 
                     process.env.REACT_APP_ENVIRONMENT === 'development';

export const devLog = {
	/**
	 * Log a message only in development
	 */
	log: (...args: unknown[]) => {
		if (isDevelopment) {
			console.log(...args);
		}
	},

	/**
	 * Log a warning only in development
	 */
	warn: (...args: unknown[]) => {
		if (isDevelopment) {
			console.warn(...args);
		}
	},

	/**
	 * Log an error only in development
	 */
	error: (...args: unknown[]) => {
		if (isDevelopment) {
			console.error(...args);
		}
	},

	/**
	 * Always log errors (even in production) as they indicate serious issues
	 * Use this for critical errors that should be visible in production
	 */
	criticalError: (...args: unknown[]) => {
		console.error(...args);
	}
};